import React from 'react';

import MuiFormLabel, {
  FormLabelProps as MuiFormLabelProps,
} from '@mui/material/FormLabel';
import clsx from 'clsx';

import { CoreProps } from '../types';
import { withCoreProps } from '../withCoreProps';

export const FormLabel = withCoreProps<FormLabelProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<FormLabelProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiFormLabel {...props} className={clsxClass}>
        {children}
      </MuiFormLabel>
    );
  },
);

export interface FormLabelProps extends MuiFormLabelProps, CoreProps {}
